
import { defineComponent, computed, onMounted } from 'vue';
import { useQuasar } from 'quasar';
import { useUser } from 'src/store/user';
import userComposable from 'src/composable/User';

import iconly from './Iconly';

export default defineComponent({
  name: 'App',
  setup() {
    const $q = useQuasar();
    $q.iconMapFn = iconly;

    const userStore = useUser();
    userStore.init();
    const loading = computed(() => {
      return userStore.loading;
    });
    onMounted(userComposable().initUser);
    return {
      loading
    };
  }
});
